module.exports = __webpack_public_path__ + "img/image_placeholder.ebe9884b.jpg";